export default from './modal-root';



// WEBPACK FOOTER //
// ./app/containers/modal-root/index.js